export default __webpack_public_path__ + "locales/ko-KR/Translations.json?hash=6bdc1bc631b931a2bf9f4e1e87ece495";